module.exports = __webpack_public_path__ + "media/images/locus_grid_icon-fc9af50f31157d89446556960bd87de0.svg";